<template>
    <div class="mt-4 mb-2" style="background-color: #fff">
        <v-layout row class="ml-0 mb-2">
            <div class="font-weight-medium mr-1 width-200">Date Created:</div>
            <div>{{ formatTime(row.dateCreated) }}</div>
        </v-layout>
        <v-layout row class="ml-0 mb-2">
            <div class="font-weight-medium mr-1 width-200">Start Date:</div>
            <div>{{ formatDate(row.startDate) }}</div>
        </v-layout>
        <v-layout row class="ml-0 mb-2">
            <div class="font-weight-medium mr-1 width-200">End Date:</div>
            <div>{{ formatDate(row.endDate) }}</div>
        </v-layout>
        <v-layout row class="ml-0 mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Next Schedule Date:
            </div>
            <div>{{ formatDate(row.nextScheduleDate) }}</div>
        </v-layout>
        <v-layout row class="ml-0 mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Last Successful Schedule:
            </div>
            <div>{{ formatDate(row.lastSuccessfulSchedule) }}</div>
        </v-layout>

        <v-layout row class="ml-0 mb-2" v-for="prop in getRowProperties()">
            <div class="font-weight-medium mr-1 width-200">
                {{ prop.name }}:
            </div>
            <div>{{ prop.value }}</div>
        </v-layout>
        <v-layout row class="ml-0 mb-2">
            <div class="font-weight-medium mr-1 width-200">Amount:</div>
            <div>{{ formatCurrency(row.totalAmount) }}</div>
        </v-layout>
        <v-layout row class="ml-0 mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Amount Processed:
            </div>
            <div>{{ formatCurrency(row.amountProcessed) }}</div>
        </v-layout>
        <v-layout row class="ml-0 mb-2">
            <div class="font-weight-medium mr-1 width-200">Schedule Count:</div>
            <div>{{ row.totalSchedules }}</div>
        </v-layout>
        <v-layout row class="ml-0 mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Schedules Processed:
            </div>
            <div>{{ row.processed }}</div>
        </v-layout>
        <v-layout row class="ml-0 mb-2">
            <div
                v-bind:class="{ 'text-danger': !row.isEnabled }"
                class="font-weight-medium mr-1 width-200"
            >
                Enebled:
            </div>
            <div v-bind:class="{ 'text-danger': !row.isEnabled }">
                {{ row.isEnabled ? "Yes" : "No" }}
            </div>
        </v-layout>

        <v-layout row class="ml-0">
            <v-btn
                v-if="row.status == 'Scheduled'"
                small
                dark
                color="default"
                @click="editSchedule"
                >Edit/Cancel Schedule</v-btn
            >

            <v-btn
                class="ml-2"
                v-if="row.source.toUpperCase().includes('DINNER')"
                @click="openCopyScheduleDialog()"
                small
                color="success"
                >Copy Schedule</v-btn
            >
        </v-layout>
        <vue-good-table
            class="schedule-detail-list"
            style="width: 92%;"
            styleClass="vgt-table striped"
            :columns="scheduleDetailColumns"
            :rows="details"
            :search-options="{
                enabled: false,
            }"
        >
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.isIcon" class="px-0">
                    <v-icon
                        class="px-0"
                        dark
                        :color="
                            props.column.iconColor(
                                props.row[props.column.field]
                            )
                        "
                        >{{
                            props.column.icon(props.row[props.column.field])
                        }}</v-icon
                    >
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>

        <v-dialog scrollable v-model="editScheduleDialog" max-width="700">
            <edit-schedule
                :schedule="scheduleCopy"
                :originalSchedule="originalSchedule"
                :closeDialog="closeEditScheduleDialog"
                :scheduleDetailColumns="scheduleDetailColumns"
                :reloadPage="reloadGrid"
                :accountID="row.accountID"
                :paymentMethods="paymentMethods"
            ></edit-schedule>
        </v-dialog>

        <v-dialog persistent v-model="copyScheduleDialog" max-width="700">
            <v-card class="px-4">
                <v-card-title class="headline pl-0 mb-2"
                    >New Schedule</v-card-title
                >

                <div v-if="!copySchedule.showConfirmView">
                    <v-layout column class="mx-0 mb-0">
                        <v-text-field
                            box
                            v-model="copySchedule.scheduleAmount"
                            label="Amount"
                            type="number"
                            prefix="$"
                            ref="scheduleAmount"
                            @input="generateSchedules()"
                            :rules="[amountRules.required, amountRules.min]"
                        ></v-text-field>
                    </v-layout>

                    <v-divider class="mb-4"></v-divider>
                    <v-text-field
                        type="number"
                        label="Number Of Payments"
                        class=""
                        ref="numberOfPayments"
                        v-model="copySchedule.numberOfPayments"
                        @input="generateSchedules()"
                        :rules="numberOfPaymentsRules"
                    ></v-text-field>
                    <v-btn-toggle
                        mandatory
                        v-model="copySchedule.scheduleMode"
                        class="mb-2"
                        @change="generateSchedules()"
                    >
                        <v-btn value="month">
                            Month
                        </v-btn>
                        <v-btn value="week">
                            Week
                        </v-btn>
                    </v-btn-toggle>
                    <v-menu
                        v-model="copySchedule.datePickerMenu"
                        :close-on-content-click="true"
                        offset-y
                        full-width
                        prepend-icon="mdi-currency-usd"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="copySchedule.startDate"
                                label="Start Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="copySchedule.startDate"
                            :min="minDate"
                            @change="generateSchedules()"
                        ></v-date-picker>
                    </v-menu>

                    <v-layout row v-for="schedule in copySchedule.schedules">
                        <v-text-field
                            class="mr-2"
                            v-model="schedule.amount"
                            label="Amount"
                            type="number"
                            prefix="$"
                            ref="scheduleDetailAmount"
                        ></v-text-field>
                        <v-menu
                            v-model="schedule.datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="schedule.date"
                                    label="Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="schedule.date"
                                :min="minDate"
                            ></v-date-picker>
                        </v-menu>
                    </v-layout>
                    <v-divider class="mt-2 mb-4"></v-divider>

                    <v-text-field
                        class="mb-2"
                        v-model="copySchedule.emailAddress"
                        label="Email Address"
                        :rules="emailRules"
                        ref="emailAddress"
                    ></v-text-field>
                    <v-text-field
                        label="Note"
                        class=""
                        v-model="copySchedule.note"
                    ></v-text-field>
                    <v-card-actions class="mx-0 pb-3">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            class="mr-1"
                            @click="copyScheduleDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn color="success" @click="confirmSchedule()">
                            Continue
                        </v-btn>
                    </v-card-actions>
                </div>

                <div v-if="copySchedule.showConfirmView">
                    <div v-if="!copySchedule.scheduleProcessed">
                        <div class="headline text-warning text-xs-center mb-4">
                            Please confirm the details below
                        </div>
                        <div
                            style="border: #4caf50 3px solid"
                            class="px-3 pt-3"
                        >
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium width-200">
                                    Payment Method
                                </div>
                                <div>
                                    {{ copySchedule.cardInfo }}
                                </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                                <div
                                    class="font-weight-medium width-200"
                                    v-if="copySchedule.emailAddress"
                                >
                                    Email Address:
                                </div>
                                <div>
                                    {{ copySchedule.emailAddress }}
                                </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                                <div
                                    class="font-weight-medium width-200"
                                    v-if="copySchedule.note"
                                >
                                    Note:
                                </div>
                                <div>
                                    {{ copySchedule.note }}
                                </div>
                            </v-layout>
                        </div>
                        <v-divider class="pb-3 mt-3"></v-divider>
                        <div v-if="getCurrentAmount()">
                            <div class="font-weight-medium title mb-3">
                                Payment
                            </div>
                            <v-data-table
                                :headers="getPaymentConfirmationHeaders()"
                                :items="getPaymentConfirmationDetails()"
                                class="elevation-2 my-3"
                                disable-sort
                                :mobile-breakpoint="NaN"
                                hide-actions
                            >
                                <template v-slot:items="props">
                                    <td>{{ props.item.category }}</td>
                                    <td class="text-xs-right">
                                        {{ props.item.amount }}
                                    </td>
                                </template>
                            </v-data-table>
                        </div>
                        <div v-if="hasScheduledPayments()">
                            <div class="font-weight-medium title mb-3">
                                Schedule
                            </div>
                            <v-data-table
                                :headers="getScheduleConfirmationHeaders()"
                                :items="getScheduleConfirmationDetails()"
                                class="elevation-2 my-3"
                                disable-sort
                                :mobile-breakpoint="NaN"
                                hide-actions
                            >
                                <template v-slot:items="props">
                                    <td class="text-xs-left">
                                        {{ props.item.date }}
                                    </td>
                                    <td class="text-xs-center">
                                        {{ props.item.amount }}
                                    </td>
                                </template>
                            </v-data-table>
                        </div>

                        <v-card-actions class="mx-0 pb-3 mt-4">
                            <div style="color: #4caf50">
                                {{ copySchedule.processingMessage }}
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="default"
                                dark
                                class="mr-1"
                                @click="closeCopyScheduleDialog()"
                                >Cancel</v-btn
                            >
                            <v-btn
                                color="default"
                                dark
                                class="mr-1"
                                @click="copySchedule.showConfirmView = false"
                                >Back</v-btn
                            >
                            <v-btn
                                color="success"
                                :loading="copySchedule.processing"
                                @click="processSchedule()"
                            >
                                Confirm
                            </v-btn>
                        </v-card-actions>
                    </div>

                    <div v-if="copySchedule.scheduleProcessed">
                        <!-- <div v-if="+getCurrentAmount() > 0" class="px-3">
                        <div v-if="paymentStatus == 'A'">
                            <v-layout justify-center>
                                <v-icon
                                    style="height: 100px;"
                                    size="100"
                                    color="#A5DC86"
                                    class="mt-2"
                                    >mdi-check-circle-outline</v-icon
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <v-card-title
                                    style="color: #4caf50"
                                    class="font-weight-medium title"
                                    >Payment Approved</v-card-title
                                >
                            </v-layout>
                        </div>
                        <div v-if="paymentStatus == 'D'">
                            <v-layout justify-center>
                                <v-icon
                                    style="height: 100px;"
                                    size="100"
                                    class="mt-2"
                                    color="rgb(243, 81, 35)"
                                    >mdi-alert</v-icon
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <v-card-title
                                    class="font-weight-medium title text-danger mb-2"
                                    >Payment Declined</v-card-title
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <div class="text-danger mb-2">
                                    {{ paymentResult }}
                                </div>
                            </v-layout>
                            <v-card-actions class="mb-2">
                                <v-spacer></v-spacer>
                                <v-btn
                                    small
                                    color="success"
                                    @click="
                                        processingMessage = '';
                                        paymentProcessed = false;
                                        scheduleProcessed = false;
                                        showConfirmView = false;
                                    "
                                    >Try Again</v-btn
                                ><v-spacer></v-spacer>
                            </v-card-actions>
                        </div>
                        <div v-if="paymentStatus == 'E'">
                            <v-layout justify-center>
                                <v-icon
                                    style="height: 100px;"
                                    size="100"
                                    class="mt-2"
                                    color="rgb(243, 81, 35)"
                                    >mdi-alert-circle</v-icon
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <v-card-title class="font-weight-medium title"
                                    >An Error Occurred</v-card-title
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <div class="text-danger text-xs-center">
                                    {{ paymentResult }}
                                </div>
                            </v-layout>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="success"
                                    small
                                    @click="
                                        processingMessage = '';
                                        paymentProcessed = false;
                                        scheduleProcessed = false;
                                        showConfirmView = false;
                                    "
                                    >Try Again</v-btn
                                ><v-spacer></v-spacer>
                            </v-card-actions>
                        </div>
                    </div> -->
                        <div
                            v-if="
                                hasScheduledPayments() &&
                                    copySchedule.scheduleProcessed
                            "
                        >
                            <!-- <v-divider
                            class="mb-3"
                            v-if="+getCurrentAmount() > 0"
                        ></v-divider> -->
                            <div v-if="!copySchedule.scheduleError">
                                <v-layout justify-center>
                                    <v-icon
                                        style="height: 100px;"
                                        size="100"
                                        color="#A5DC86"
                                        class="mt-2"
                                        >mdi-check-circle-outline</v-icon
                                    >
                                </v-layout>
                                <v-layout justify-center>
                                    <v-card-title
                                        style="color: #4caf50"
                                        class="font-weight-medium title"
                                        >Payments Scheduled</v-card-title
                                    >
                                </v-layout>
                                <v-divider class="mb-3"></v-divider>
                                <v-layout row class="my-3">
                                    <div class="font-weight-medium">DATE</div>
                                    <v-spacer style="width: 22%;"></v-spacer>
                                    <div class="font-weight-medium">AMOUNT</div>
                                </v-layout>
                                <v-divider class="mb-3"></v-divider>
                                <div
                                    v-for="(schedule,
                                    index) in getSchedulePayments()"
                                >
                                    <v-layout row class="my-3">
                                        <div>{{ schedule.date | date }}</div>
                                        <v-spacer></v-spacer>
                                        <div>
                                            {{ schedule.amount | currency }}
                                        </div>
                                    </v-layout>
                                    <v-divider
                                        v-if="
                                            index + 1 <
                                                getSchedulePayments().length
                                        "
                                        :key="index"
                                    ></v-divider>
                                </div>
                            </div>
                            <div v-if="copySchedule.scheduleError">
                                <v-layout justify-center>
                                    <v-icon
                                        style="height: 100px;"
                                        size="100"
                                        class="mt-2"
                                        color="rgb(243, 81, 35)"
                                        >mdi-alert-circle</v-icon
                                    >
                                </v-layout>
                                <v-layout justify-center>
                                    <v-card-title
                                        class="font-weight-medium title"
                                        >An error occurred while setting up the
                                        schedule</v-card-title
                                    >
                                </v-layout>
                                <div class="text-danger text-xs-center">
                                    {{ copySchedule.scheduleError }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <v-card-actions
                    class="mr-0 pb-3"
                    v-if="copySchedule.scheduleProcessed"
                >
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="copyScheduleDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {
    formatCurrency,
    except,
    toTitleCase,
    toISOLocal,
    sum,
} from "../../utils/helpers.js";
import editSchedule from "../Account/EditScheduledPayments.vue";
import moment from "moment";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    components: {
        "edit-schedule": editSchedule,
    },
    data() {
        return {
            details: [],
            editScheduleDialog: false,
            scheduleCopy: {
                scheduleDetails: [],
            },
            originalSchedule: {
                scheduleDetails: [],
            },

            paymentMethods: [],

            minDate: moment().format("YYYY-MM-DD HH:mm:ss"),
            minDate: moment()
                .add(1, "days")
                .format("YYYY-MM-DD HH:mm:ss"),

            copyScheduleDialog: false,

            copySchedule: {
                scheduleAmount: "",
                numberOfPayments: 2,
                showConfirmView: false,
                scheduleMode: "month",
                datePickerMenu: false,
                startDate: toISOLocal(new Date(moment().add(1, "days"))).substr(
                    0,
                    10
                ),
                emailAddress: "",
                note: "",
                cardInfo: "",
                scheduleError: "",
                scheduleProcessed: false,
                processingMessage: "",
                processing: false,
            },

            numberOfPaymentsRules: [
                (value) => !!value || "Number Of Payments Is Required",
                (value) => !value || value > 0 || "minimum 1 schedule required",
            ],

            amountRules: {
                required: (value) =>
                    value > 0 ||
                    +this.scheduleCopy.scheduleAmount > 0 ||
                    "Amount is Required",
                min: (value) => {
                    return !value || value >= 0 || "Amount can't be negative";
                },
            },

            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],

            scheduleDetailColumns: [
                {
                    sortable: true,
                    field: "status",
                    hidden: false,
                    isIcon: true,
                    icon: (value, row) => {
                        if (!value) return "";

                        if (value.toUpperCase().startsWith("ERROR"))
                            return "mdi-alert-circle";

                        switch (value.toUpperCase()) {
                            case "APPROVED":
                                return "mdi-check-circle";
                            case "SCHEDULED":
                                return "mdi-clock";
                            case "DECLINED":
                                return "mdi-alert";
                            case "CANCELED":
                                return "mdi-close-circle";
                            default:
                                return "";
                        }
                    },
                    iconColor: (value, row) => {
                        if (!value) return "";

                        if (value.toUpperCase().startsWith("ERROR"))
                            return "#f35123";

                        switch (value.toUpperCase()) {
                            case "APPROVED":
                                return "success";
                            case "SCHEDULED":
                                return "#fdb400";
                            case "DECLINED":
                                return "#f35123";
                            case "CANCELED":
                                return "#aeb8bf";
                            default:
                                return "";
                        }
                    },
                },
                {
                    sortable: true,
                    label: "Date",
                    field: "scheduleDate",
                    hidden: false,
                    type: "date",
                    width: "100px",
                    dateOutputFormat: "MM/DD/YYYY",
                },
                {
                    sortable: true,
                    label: "Amount",
                    field: "amount",
                    type: "decimal",
                    width: "100px",
                    hidden: false,
                    formatFn: (value) => formatCurrency(value),
                },
                {
                    sortable: false,
                    label: "Details",
                    field: "details",
                    hidden: false,
                    width: "250px",
                    formatFn: (value) => {
                        if (!value) return "";

                        const categories = new Map([
                            ["TC", "Tuition"],
                            ["TRNS", "Transportation"],
                            ["LAPC", "Lapidus"],
                        ]);

                        return value
                            .split("|")
                            .map((detail) => {
                                const category =
                                    categories.get(detail.split(":")[0]) ||
                                    detail.split(":")[0];
                                const amount = detail.split(":")[1];

                                return category + ": " + formatCurrency(amount);
                            })
                            .sort()
                            .reverse()
                            .join(" | ");
                    },
                },
                {
                    sortable: false,
                    label: "Card",
                    field: "cardInfo",
                    width: "220px",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "Status",
                    field: "status",
                    width: "100px",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Process Date",
                    field: "processDate",
                    type: "date",
                    width: "215px",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                },
                {
                    label: "Attempts",
                    field: "attempts",
                    type: "number",
                    sortable: false,
                    width: "150px",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Canceled At",
                    field: "cancelDate",
                    type: "date",
                    width: "215px",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Canceled By",
                    field: "canceledBy",
                    width: "150px",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Updated By",
                    field: "userUpdated",
                    width: "150px",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Last Updated",
                    field: "lastUpdated",
                    type: "date",
                    width: "200px",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                },
            ],
        };
    },
    async created() {
        this.loadScheduleDetails();
        this.loadSavedCards();
        this.generateSchedules();
    },
    computed: {},
    methods: {
        async loadScheduleDetails() {
            const details = await this.$http.get(
                "api/schedules/getScheduleDetails?scheduleID=" +
                    this.row.scheduleID
            );

            this.details = details.map((detail) => {
                detail.cardInfo = detail.cardType + " - " + detail.cardNumLast5;

                return detail;
            });

            ["canceledBy", "cancelDate", "userUpdated", "lastUpdated"].forEach(
                (field) => {
                    if (details.some((detail) => detail[field])) {
                        this.scheduleDetailColumns.find(
                            (c) => c.field == field
                        ).hidden = false;
                    }
                }
            );
        },
        async loadSavedCards() {
            const paymentMethods = await this.$http.get(
                "api/payments/getSavedCards?accountID=" + this.row.accountID
            );

            this.paymentMethods = paymentMethods.map((method) => {
                method.cardInfo =
                    method.cardType + " - " + method.cardNumberLast5;

                return method;
            });
        },
        formatCurrency(amount) {
            return formatCurrency(amount);
        },
        closeEditScheduleDialog() {
            this.editScheduleDialog = false;
        },
        editSchedule() {
            const scheduleDetails = this.details
                .filter((s) => s.status == "Scheduled")
                .map((detail) => {
                    detail.datePickerMenu = false;
                    detail.selected = false;
                    detail.scheduleDetailId = detail.scheduleDetailID;
                    detail.scheduleId = detail.scheduleID;

                    detail.scheduleDate = new Date(detail.scheduleDate)
                        .toISOString()
                        .substr(0, 10);

                    return detail;
                });

            this.scheduleCopy.scheduleDetails = JSON.parse(
                JSON.stringify(scheduleDetails)
            );

            this.originalSchedule = JSON.parse(
                JSON.stringify(this.scheduleCopy)
            );

            this.editScheduleDialog = true;
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        formatDate(date) {
            if (!date) return;

            return moment(date).format("L");
        },
        getRowProperties() {
            return Object.keys(
                except(
                    this.row,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "dateCreated",
                    "startDate",
                    "endDate",
                    "totalAmount",
                    "amountProcessed",
                    "totalSchedules",
                    "processed",
                    "nextScheduleDate",
                    "lastSuccessfulSchedule"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: this.row[key],
                    };
                })
                .filter((p) => p.value);
        },
        openCopyScheduleDialog() {
            this.copyScheduleDialog = true;

            this.copySchedule.emailAddress = this.row.emailAddress;
            this.copySchedule.cardInfo =
                this.row.cardType + " - " + this.row.cardNumLast5;
        },
        closeCopyScheduleDialog() {
            this.copyScheduleDialog = false;
        },
        generateSchedules() {
            this.copySchedule.schedules = [];

            const amount =
                +this.copySchedule.scheduleAmount /
                this.copySchedule.numberOfPayments;

            for (var i = 0; i < this.copySchedule.numberOfPayments; i++) {
                const schedule = {
                    date: this.copySchedule.startDate,
                    amount: 0,
                    datePickerMenu: false,
                };

                schedule.amount = +amount.toFixed(2);

                schedule.date = toISOLocal(
                    this.copySchedule.scheduleMode == "month"
                        ? new Date(
                              moment(this.copySchedule.startDate).add(
                                  i,
                                  "months"
                              )
                          )
                        : new Date(
                              moment(this.copySchedule.startDate).add(
                                  i,
                                  "weeks"
                              )
                          )
                ).substr(0, 10);

                this.copySchedule.schedules.push(schedule);
            }
        },
        getSchedulePayments() {
            return this.copySchedule.schedules.filter(
                (s) => this.isScheduledPayment(s.date) && +s.amount > 0
            );
        },
        isScheduledPayment(date) {
            return !this.isminDate(date);
        },
        isminDate(date) {
            return moment(date).isSame(new Date(), "day");
        },
        getCurrentAmount() {
            return sum(
                this.copySchedule.schedules
                    .filter((s) => this.isminDate(s.date))
                    .map((s) => +s.tuitionAmount)
            );
        },
        hasScheduledPayments() {
            return this.copySchedule.schedules
                .filter((s) => +s.amount > 0)
                .some((s) => this.isScheduledPayment(s.date));
        },
        getScheduleConfirmationHeaders() {
            return [
                {
                    text: "DATE",
                    value: "date",
                    align: "left",
                    sortable: false,
                },
                {
                    text: "AMOUNT",
                    align: "center",
                    value: "amount",
                    sortable: false,
                },
            ];
        },
        getScheduleConfirmationDetails() {
            return this.copySchedule.schedules
                .filter((s) => +s.amount > 0 && this.isScheduledPayment(s.date))
                .map((schedule) => {
                    return {
                        date: moment(schedule.date).format("L"),
                        amount: formatCurrency(schedule.amount),
                    };
                });
        },
        validate() {
            const validations = [
                this.$refs.scheduleAmount.validate(true),
                this.$refs.emailAddress.validate(true),
                this.$refs.numberOfPayments.validate(true),
            ];

            return validations.every(Boolean);
        },
        confirmSchedule() {
            if (!this.validate()) return;

            this.copySchedule.showConfirmView = true;
        },
        async processSchedule() {
            try {
                this.copySchedule.processing = true;
                this.copySchedule.scheduleError = "";
                this.copySchedule.scheduleProcessed = false;
                this.copySchedule.processingMessage = "Processing Schedules";

                await this.$http.post("api/schedules/copySchedule", {
                    scheduleID: this.row.scheduleID,
                    accountID: this.row.accountID,
                    emailAddress: this.copySchedule.emailAddress,
                    note: this.copySchedule.note,
                    user: this.$store.state.authentication.user,
                    isTest: window.location.origin.startsWith(
                        "http://localhost"
                    ),
                    scheduleDetails: this.getSchedulePayments().map(
                        (schedule) => {
                            return {
                                amount: schedule.amount,
                                scheduleDate: schedule.date,
                            };
                        }
                    ),
                });

                this.copySchedule.processing = false;
                this.copySchedule.scheduleProcessed = true;
                //this.closeCopyScheduleDialog();
                this.reloadGrid();
            } catch (e) {
                console.log(e);
                this.copySchedule.processing = false;
                this.copySchedule.scheduleError = e;
            }
        },
    },
};
</script>
<style>
.schedule-detail-list .vgt-table {
    border: 1px solid #ddd !important;
}

.schedule-detail-list table.vgt-table td {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    padding-left: 8px !important;
    font-weight: 400 !important;
}

.schedule-detail-list tr:nth-child(even) {
    background-color: #fff !important;
}
</style>
